import Button from "src/components/Button";
import Modal from "src/components/Modal/Modal";
import { JobInterview, Talent } from "src/types";
import { CardBody } from "./TalentCard";
import DropdownSelect from "src/components/Form/DropdownSelect/DropdownSelect";
import Job from "src/types/models/Job";
import { useEffect, useState } from "react";
import { bulkInvite, getInterviewsPaginated } from "src/network/interview";
import { getJobsPaginated } from "src/network/job";
import { Option } from "src/components/Form/DropdownSelect/Options";
import useLoader from "src/hooks/useLoader";
import { useAppSelector } from "src/redux/store";
import ConstraintModal from "src/components/Modal/ConstraintModal";

const InviteModal = ({ talent }: { talent: Talent }) => {
  const limit = useAppSelector(
    (r) => !!r.client.client?.Company.UsageConstraints?.completed_monthly_job_interviews_exceeded
  );
  const [open, setOpen] = useState(false);
  // We need interview data to be able to invite the talent
  const [intws, setIntws] = useState<JobInterview[]>();
  const [job, setJob] = useState<Option>();

  //   Send invite
  const sendInvite = async () => {
    const response = await bulkInvite({
      job_id: job?.value as any,
      data: [
        {
          email: talent.User.email_id,
          first_name: talent.User.first_name || "User",
          last_name: talent.User.last_name || ""
        }
      ]
    });
    const { invited } = response;
    if (invited.length) setIntws([...(intws || []), invited[0]]);
    setOpen(false);
  };
  const { ldng: sendInvt, loading } = useLoader(sendInvite, {
    errorMsg: "Error sending invite",
    successMsg: "Talent was Invited"
  });

  const [jobs, setJobs] = useState<Job[]>();
  const fetchInterviewData = async () => {
    const interviews = await getInterviewsPaginated({ email: talent.User.email_id });
    const jobs = await getJobsPaginated({ attributes: ["id", "job_title"] });
    setIntws(interviews.data);
    setJobs(jobs.data);
  };
  useEffect(() => {
    fetchInterviewData();
  }, []);

  if (!intws || !jobs) return <Button shapeVariant={2} loading={true} />;

  const options = jobs.map((j) => ({ value: j.id, label: j.job_title }));
  const invitesMap: { [key in number]: boolean } = {};
  intws.forEach((i) => (invitesMap[i.job_id] = true));
  const invitedAlready = invitesMap[job?.value || 0];

  return (
    <>
      <Button onClick={() => setOpen(true)} shapeVariant={2}>
        Invite for interview
      </Button>
      <Modal open={open && !limit} onChange={setOpen} className="!w-[556px]">
        <p className="font-poppins text-xl font-semibold text-center mb-6">Invite Talent</p>

        <div className="border-[#F9F9F9] border-[1px] p-3 rounded-lg">
          <CardBody talent={talent} />
        </div>

        <p className="font-poppins text-sm font-medium mt-6">Select job for candidate invitation</p>
        <DropdownSelect
          value={job}
          onChange={(j) => setJob(j)}
          className=" mt-3 "
          controlClassName="!h-9"
          options={options}
        />

        <Button
          onClick={sendInvt}
          loading={loading}
          disabled={!job || invitedAlready}
          className="mx-auto mt-6"
          shapeVariant={2}
        >
          {invitedAlready ? "Invited" : "Send Invite"}
        </Button>
      </Modal>
      <ConstraintModal
        open={open && limit}
        variant="month_int_limit"
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default InviteModal;
